import { createFileRoute } from '@tanstack/react-router';
import { CompositionsService } from '../../../../services/CompositionsService';
import { TransientError } from '../../../../types/errors';

export const Route = createFileRoute('/_authenticated/canvases/$canvasId/remove')({
  component: () => null,
  loader: async ({ params }) => {
    const { canvasId } = params;

    const canvas = await CompositionsService.getCompositionFromMemory(canvasId);

    if (!canvas) {
      throw new TransientError('Canvas not found');
    }

    return canvas;
  },
});
